export default __webpack_public_path__ + "static/media/webcamBG.3a25a57c.png";